export default "<template>\n\n  <KButton text=\"Raised Button\" />\n\n</template>\n";